const SurveyReports = () => {}

export default SurveyReports
